import React, { useState, useRef, useCallback, useEffect } from "react";
import { Button, Container, Modal, ModalHeader, ModalBody } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import { injectIntl } from "react-intl";
import IntlMessages from "../../helpers/IntlMessages";

const AddCommaNumber = (num) => {
  if (!num) return "0";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const getFeatures = (intl) => [
  {
    title: intl.formatMessage({ id: "upgrade.feature.billing" }),
    free: true,
    basic: true,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.print_invoice" }),
    free: true,
    basic: true,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.accounts" }),
    free: true,
    basic: true,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.sales" }),
    free: true,
    basic: true,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.products" }),
    free: intl.formatMessage({ id: "upgrade.value.products.free" }),
    basic: intl.formatMessage({ id: "upgrade.value.products.basic" }),
    pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.materials" }),
    free: intl.formatMessage({ id: "upgrade.value.materials.free" }),
    basic: intl.formatMessage({ id: "upgrade.value.materials.basic" }),
    pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.staff" }),
    free: intl.formatMessage({ id: "upgrade.value.staff.free" }),
    basic: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    pro: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    pro_auto: intl.formatMessage({ id: "upgrade.value.unlimited" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.unlimited" }),
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.reports" }),
    free: intl.formatMessage({ id: "upgrade.value.reports.basic" }),
    basic: intl.formatMessage({ id: "upgrade.value.reports.detailed" }),
    pro: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
    pro_auto: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.reports.advanced" }),
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.chain" }),
    free: false,
    basic: false,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.social" }),
    free: false,
    basic: false,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.shipping" }),
    free: false,
    basic: false,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.ecommerce" }),
    free: false,
    basic: false,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.einvoice" }),
    free: false,
    basic: false,
    pro: true,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.api" }),
    free: false,
    basic: false,
    pro: false,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.api-limit" }),
    free: false,
    basic: false,
    pro: false,
    pro_auto: intl.formatMessage({ id: "upgrade.value.api.limit" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.api.custom" }),
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.automation" }),
    free: false,
    basic: false,
    pro: false,
    pro_auto: true,
    enterprise: true,
  },
  {
    title: intl.formatMessage({ id: "upgrade.feature.support" }),
    free: intl.formatMessage({ id: "upgrade.value.support.docs" }),
    basic: intl.formatMessage({ id: "upgrade.value.support.online" }),
    pro: intl.formatMessage({ id: "upgrade.value.support.online" }),
    pro_auto: intl.formatMessage({ id: "upgrade.value.support.priority" }),
    enterprise: intl.formatMessage({ id: "upgrade.value.support.priority" }),
  },
];

const getPricesBasic = (intl) => [
  {
    label: intl.formatMessage({ id: "upgrade.time.1m" }),
    price: "99000",
    price_sale: "",
    value: "1m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.6m" }),
    price: "594000",
    price_sale: "",
    value: "6m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.1y" }),
    price: "1188000",
    price_sale: "",
    value: "1y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.2y" }),
    price: "2376000",
    price_sale: "",
    value: "2y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.5y" }),
    price: "5940000",
    price_sale: "",
    value: "5y",
  },
];

const getPricesPro = (intl) => [
  {
    label: intl.formatMessage({ id: "upgrade.time.1m" }),
    price: "299000",
    price_sale: "",
    value: "1m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.6m" }),
    price: "1794000",
    price_sale: "",
    value: "6m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.1y" }),
    price: "3588000",
    price_sale: "",
    value: "1y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.2y" }),
    price: "7176000",
    price_sale: "",
    value: "2y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.5y" }),
    price: "17940000",
    price_sale: "",
    value: "5y",
  },
];

const getPricesProAuto = (intl) => [
  {
    label: intl.formatMessage({ id: "upgrade.time.1m" }),
    price: "599000",
    price_sale: "",
    value: "1m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.6m" }),
    price: "3594000",
    price_sale: "",
    value: "6m",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.1y" }),
    price: "7188000",
    price_sale: "",
    value: "1y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.2y" }),
    price: "14376000",
    price_sale: "",
    value: "2y",
  },
  {
    label: intl.formatMessage({ id: "upgrade.time.5y" }),
    price: "35940000",
    price_sale: "",
    value: "5y",
  },
];

const PricingPage = ({ intl }) => {
  const pricesBasic = getPricesBasic(intl);
  const pricesPro = getPricesPro(intl);
  const pricesProAuto = getPricesProAuto(intl);
  const features = getFeatures(intl);

  // Modal States
  const [modalBasic, setModalBasic] = useState(false);
  const [modalPro, setModalPro] = useState(false);
  const [modalProAuto, setModalProAuto] = useState(false);

  // Selection States
  const [selectedDurations, setSelectedDurations] = useState({
    basic: pricesBasic[0],
    pro: pricesPro[0],
    pro_auto: pricesProAuto[0],
  });

  const toggleBasic = () => setModalBasic(!modalBasic);
  const togglePro = () => setModalPro(!modalPro);
  const toggleProAuto = () => setModalProAuto(!modalProAuto);

  const getPackageConfig = () => [
    {
      key: "free",
      title: intl.formatMessage({ id: "upgrade.package.free.title" }),
      price: "0",
      sub: "đ",
      icon: "iconsminds-bread",
      color: "text-muted",
      btnText: intl.formatMessage({ id: "upgrade.btn.try" }),
      action: () => handleRegister({ key: "free" }),
    },
    {
      key: "basic",
      title: intl.formatMessage({ id: "upgrade.package.basic.title" }),
      price: "99.000",
      sub: intl.formatMessage({ id: "upgrade.price.sub.month" }),
      icon: "iconsminds-coins",
      color: "text-primary",
      btnText: intl.formatMessage({ id: "upgrade.btn.register" }),
      action: toggleBasic,
    },
    {
      key: "pro",
      title: intl.formatMessage({ id: "upgrade.package.pro.title" }),
      price: "299.000",
      sub: intl.formatMessage({ id: "upgrade.price.sub.month" }),
      icon: "iconsminds-diamond",
      color: "text-primary",
      btnText: intl.formatMessage({ id: "upgrade.btn.register" }),
      action: togglePro,
      isPopular: true,
    },
    {
      key: "pro_auto",
      title: intl.formatMessage({ id: "upgrade.package.pro_auto.title" }),
      price: "599.000",
      sub: intl.formatMessage({ id: "upgrade.price.sub.month" }),
      icon: "iconsminds-gear",
      color: "text-danger",
      btnText: intl.formatMessage({ id: "upgrade.btn.register" }),
      action: toggleProAuto,
    },
    {
      key: "enterprise",
      title: intl.formatMessage({ id: "upgrade.package.enterprise.title" }),
      price: intl.formatMessage({ id: "upgrade.contact" }),
      sub: "",
      icon: "iconsminds-building",
      color: "text-secondary",
      btnText: intl.formatMessage({ id: "upgrade.btn.contact" }),
      action: () => window.open("https://vmass.vn", "_blank"),
    },
  ];

  const packageConfig = getPackageConfig();

  const handleDurationChange = (pkg, selected) => {
    setSelectedDurations((prev) => ({
      ...prev,
      [pkg]: selected,
    }));
  };

  const handleRegister = (pkg) => {
    // Determine if we're on local or production
    const hostname = window.location.hostname;
    const isLocal =
      hostname.includes("localhost") || hostname.includes("127.0.0.1");
    const protocol = window.location.protocol;
    const port = window.location.port ? `:${window.location.port}` : "";

    // Build base register URL based on environment
    let registerBaseUrl;
    if (isLocal) {
      // Local: use register.localhost with same port
      registerBaseUrl = `${protocol}//register.localhost${port}`;
    } else {
      // Production: use register.vmass.vn
      registerBaseUrl = `https://register.vmass.vn`;
    }

    // If inside iframe, try to open in parent or new window
    const isInIframe = window.self !== window.top;
    let target = isInIframe ? "_blank" : "_self";

    if (pkg.key === "enterprise") {
      window.open("https://vmass.vn", "_blank");
      return;
    }

    if (pkg.key === "free") {
      const url = `${registerBaseUrl}/user/register`;
      window.open(url, target);
      return;
    }

    const duration = selectedDurations[pkg.key]?.value || "1m";
    const url = `${registerBaseUrl}/user/register?upgrade=${pkg.key}&duration=${duration}`;
    window.open(url, target);
  };

  const renderPaymentModal = (
    modalState,
    toggleFunc,
    pkgKey,
    priceOptions,
    selectedOption,
  ) => {
    const pkg = packageConfig.find((p) => p.key === pkgKey);
    if (!pkg) return null;

    return (
      <Modal isOpen={modalState} toggle={toggleFunc} className="modal-lg">
        <ModalHeader toggle={toggleFunc}>
          <IntlMessages id="upgrade.btn.register" /> - {pkg.title}
        </ModalHeader>
        <ModalBody>
          <div className="text-center mb-4">
            <h4 className="font-weight-bold">{pkg.title}</h4>
            <div className={`${pkg.color} display-4 font-weight-bold`}>
              {pkg.price}
            </div>
          </div>

          <div className="mb-4 d-flex justify-content-center">
            <div style={{ minWidth: "300px" }}>
              <label className="text-muted mb-2">
                <IntlMessages id="upgrade.modal.payment.term" />
              </label>
              <Select
                value={selectedOption}
                options={priceOptions}
                onChange={(val) => handleDurationChange(pkgKey, val)}
                classNamePrefix="react-select"
                formatOptionLabel={(option) => (
                  <div className="d-flex justify-content-between">
                    <span>{`${option.label} - `}</span>
                    <span className="font-weight-bold ml-1">
                      {AddCommaNumber(option.price)} đ
                    </span>
                  </div>
                )}
              />
            </div>
          </div>

          {selectedOption && (
            <div className="text-center bg-theme-card p-3 rounded mb-4">
              <h5 className="mb-0">
                <IntlMessages
                  id="upgrade.price.currency"
                  values={{ price: AddCommaNumber(selectedOption.price) }}
                />
              </h5>
            </div>
          )}

          <div className="text-center">
            <Button
              color="primary"
              size="lg"
              className="px-5 py-2"
              onClick={() => handleRegister(pkg)}
            >
              <IntlMessages id="upgrade.btn.register" />
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  // Helper to render buttons in table
  const getButton = (item) => {
    return (
      <Button
        color="primary"
        className={`btn-multiple-state btn-shadow ${
          item.isPopular ? "default" : "outline is-outline"
        }`}
        onClick={item.action}
        outline={!item.isPopular}
        style={!item.isPopular ? { borderWidth: "1px" } : {}}
      >
        {item.btnText}
      </Button>
    );
  };

  return (
    <div className="pricing-page">
      {/* Modals */}
      {renderPaymentModal(
        modalBasic,
        toggleBasic,
        "basic",
        pricesBasic,
        selectedDurations.basic,
      )}
      {renderPaymentModal(
        modalPro,
        togglePro,
        "pro",
        pricesPro,
        selectedDurations.pro,
      )}
      {renderPaymentModal(
        modalProAuto,
        toggleProAuto,
        "pro_auto",
        pricesProAuto,
        selectedDurations.pro_auto,
      )}

      {/* Header */}
      <div
        className="pricing-header text-center py-5"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
        }}
      >
        <Container>
          <div className="mb-4">
            <a href="https://vmass.vn">
              <img
                src="/assets/img/logo-horizontal.svg"
                alt="VMASS"
                style={{ height: 50 }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </a>
          </div>
          <h1 className="display-4 font-weight-bold mb-3">
            <IntlMessages id="pricing.title" />
          </h1>
          <p className="lead mb-0" style={{ opacity: 0.9 }}>
            <IntlMessages id="pricing.subtitle" />
          </p>
        </Container>
      </div>

      {/* Pricing Table */}
      <Container className="py-5">
        <div className="table-responsive">
          <PerfectScrollbar
            options={{ suppressScrollY: true, wheelPropagation: true }}
          >
            <table className="table table-borderless table-upgrade">
              <thead>
                <tr>
                  <th style={{ width: "20%" }}></th>
                  {packageConfig.map((item, index) => (
                    <th
                      key={index}
                      className={`text-center align-bottom px-3 ${
                        item.isPopular
                          ? "popular-column-header pricing-highlight-bg"
                          : ""
                      }`}
                      style={
                        item.isPopular
                          ? {
                              borderTopLeftRadius: "15px",
                              borderTopRightRadius: "15px",
                              border: "2px solid #4f6dadff",
                              borderBottom: "none",
                              position: "relative",
                              zIndex: 10,
                              paddingTop: "40px",
                              paddingBottom: "30px",
                            }
                          : {
                              paddingBottom: "30px",
                            }
                      }
                    >
                      <h4 className="font-weight-bold mb-2">{item.title}</h4>
                      <h2
                        className="font-weight-bold mb-0"
                        style={{ color: item.isPopular ? "#000" : "inherit" }}
                      >
                        {item.price}
                        <small
                          className="text-small text-muted d-block"
                          style={{ fontSize: "14px" }}
                        >
                          {item.sub}
                        </small>
                      </h2>
                      {item.isPopular && (
                        <div
                          className="position-absolute bg-primary text-white px-3 py-1 font-weight-bold rounded-bottom"
                          style={{
                            top: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "0.8rem",
                            zIndex: 11,
                            whiteSpace: "nowrap",
                            minWidth: "max-content",
                          }}
                        >
                          <IntlMessages id="upgrade.tag.popular" />
                        </div>
                      )}
                      <div className="mt-4">{getButton(item)}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="bg-theme-card">
                  <td
                    colSpan={packageConfig.length + 1}
                    className="font-weight-bold py-3 pl-4"
                  >
                    <i className="iconsminds-check text-primary mr-2" />
                    <IntlMessages id="upgrade.features" />
                  </td>
                </tr>
                {features.map((feature, fIdx) => (
                  <tr key={fIdx}>
                    <td className="py-3 align-middle border-bottom text-muted font-weight-medium pl-4">
                      {feature.title}
                    </td>
                    {packageConfig.map((item, pIdx) => {
                      const val = feature[item.key];
                      let content = (
                        <i className="simple-icon-minus text-muted" />
                      );

                      if (val === true) {
                        content = (
                          <div
                            className="rounded-circle d-inline-flex justify-content-center align-items-center bg-primary"
                            style={{
                              width: "24px",
                              height: "24px",
                              color: "white",
                            }}
                          >
                            <i
                              className="simple-icon-check"
                              style={{ fontSize: "12px" }}
                            />
                          </div>
                        );
                      } else if (val === false) {
                        content = (
                          <i className="simple-icon-close text-danger" />
                        );
                      } else if (
                        typeof val === "string" ||
                        typeof val === "number"
                      ) {
                        content = (
                          <span className="font-weight-bold">{val}</span>
                        );
                      }

                      return (
                        <td
                          key={pIdx}
                          className={`text-center align-middle border-bottom ${
                            item.isPopular
                              ? "popular-column-body pricing-highlight-bg"
                              : ""
                          }`}
                          style={
                            item.isPopular
                              ? {
                                  borderLeft: "2px solid #4f6dadff",
                                  borderRight: "2px solid #4f6dadff",
                                }
                              : {}
                          }
                        >
                          {content}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr>
                  <td></td>
                  {packageConfig.map((item, index) => (
                    <td
                      key={index}
                      className={`text-center align-middle ${
                        item.isPopular
                          ? "popular-column-footer pricing-highlight-bg"
                          : ""
                      }`}
                      style={
                        item.isPopular
                          ? {
                              borderBottomLeftRadius: "15px",
                              borderBottomRightRadius: "15px",
                              border: "2px solid #4f6dadff",
                              borderTop: "none",
                              paddingBottom: "20px",
                            }
                          : {}
                      }
                    ></td>
                  ))}
                </tr>
              </tbody>
            </table>
          </PerfectScrollbar>
        </div>

        {/* FAQ / Additional Info */}
        <div className="text-center mt-5 pt-4">
          <h4 className="mb-3">
            <IntlMessages id="pricing.support.title" />
          </h4>
          <p className="text-muted mb-4">
            <IntlMessages id="pricing.support.desc" />
          </p>
          <div>
            <Button
              color="outline-primary"
              className="mr-3"
              onClick={() => window.open("https://vmass.vn", "_blank")}
            >
              <i className="simple-icon-globe mr-2" />
              <IntlMessages id="pricing.btn.home" />
            </Button>
            <Button
              color="outline-success"
              onClick={() =>
                window.open("https://zalo.me/0708245246", "_blank")
              }
            >
              <i className="simple-icon-bubbles mr-2" />
              <IntlMessages id="pricing.btn.zalo" />
            </Button>
          </div>
        </div>
      </Container>

      {/* Footer */}
      <div className="pricing-footer py-4 text-center">
        <Container>
          <p className="text-muted mb-0">
            <IntlMessages
              id="pricing.footer.copyright"
              values={{ year: new Date().getFullYear() }}
            />
          </p>
        </Container>
      </div>

      {/* Custom Styles */}
      <style>
        {`
          .pricing-page {
            min-height: 100vh;
            // Background managed by SCSS
          }
          .table-upgrade th, .table-upgrade td {
              vertical-align: middle;
          }
          .is-outline {
             border: 1px solid #145388 !important;
             color: #145388 !important;
             background: transparent !important;
          }
          .is-outline:hover {
             background: #145388 !important;
             color: white !important;
          }
        `}
      </style>
    </div>
  );
};

export default injectIntl(PricingPage);
